<template>
  <div class="breadcrumbs-select" :class="{ open: isOpened && isTablet }">
    <div
      v-if="isTablet || last"
      class="breadcrumbs-select-header"
      itemprop="item"
      @click="onHeaderClick"
    >
      <span class="body-m-regular" itemprop="name">{{ list[0].title }}</span>
    </div>
    <nuxt-link
      v-else
      :to="list[0].slug ? `/${list[0].slug}/` : '/'"
      class="breadcrumbs-select-header body-m-regular"
      :alt="list[0].title"
      itemprop="item"
    >
      <span class="body-m-regular" itemprop="name">{{ list[0].title }}</span>
    </nuxt-link>
    <div
      ref="listBody"
      class="breadcrumbs-select-list-wrapper"
      @click="onPopup(false)"
    >
      <div
        v-if="!isPageSpeedBot"
        class="scroll-bread"
        @click.stop="onPopup(false)"
      >
        <perfect-scrollbar
          class="breadcrumbs-select-list"
          :options="{ wheelPropagation: false }"
        >
          <div class="tablet-title text-h3-bold-up">
            Смежные категории
            <div class="icon-close" @click="onPopup(false)" />
          </div>
          <component
            :is="(last && item.current) || disabled ? 'div' : nuxtLinkComponent"
            v-for="(item, index) in viewList"
            :key="`link-select-${index}`"
            :class="[
              'link-select',
              'body-m-regular',
              { checked: item.current },
            ]"
            :to="item.slug ? `/${item.slug}/` : '/'"
            :alt="item.title"
          >
            {{ item.title }}
          </component>
        </perfect-scrollbar>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { BreadcrumbsChildren } from '~/interfaces/api';
import { useMediaQueryStore } from '~/stores/mediaQuery';
import { useInteractiveStore } from '~/stores/interactive';

const props = defineProps({
  list: {
    type: Array as () => BreadcrumbsChildren[],
    required: true,
  },
  last: {
    type: Boolean,
    default: false,
  },
});
const mediaStore = useMediaQueryStore();
const interactiveStore = useInteractiveStore();
const isPageSpeedBot = computed(() => interactiveStore.isPageSpeedBot);
const isOpened = ref<boolean>(false);
const disabled = ref<boolean>(false);
const nuxtLinkComponent = shallowRef(defineNuxtLink({}));
const isTablet = computed(() => mediaStore.isTablet);
const listBody = ref<HTMLElement>();
const viewList = computed(() => {
  return props.list;
});

watch(
  () => isTablet.value,
  () => {
    onPopup(false);
  }
);

function onPopup(open: boolean): void {
  if (open) {
    isOpened.value = true;
    nextTick(() => {
      if (listBody.value) {
        const scrollWidth =
          listBody.value?.offsetWidth - listBody.value.clientWidth;
        document.body.classList.add('tablet-overflow-hidden');
        document.body.style.paddingRight = scrollWidth + 'px';
      }
    });
  } else {
    isOpened.value = false;
    document.body.classList.remove('tablet-overflow-hidden');
    document.body.style.paddingRight = '';
  }
}

function onHeaderClick(): void {
  if (isTablet.value) onPopup(true);
}
</script>

<style scoped lang="scss" src="./breadcrumbs-select_scss.scss" />
